import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LockKey } from "@phosphor-icons/react";
import {
    loadRestrictedAccessStatus,
    unlockRestrictedAccess,
} from "../redux/slice/restrictedAccessSlice";

const RestrictedRoute = ({ title = "this section" }) => {
    const [password, setPassword] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { unlocked, isStatusLoaded, isVerifying, errorMessage } = useSelector(
        (state) => state.restrictedAccess,
    );

    useEffect(() => {
        if (!isStatusLoaded) {
            dispatch(loadRestrictedAccessStatus());
        }
    }, [dispatch, isStatusLoaded]);

    if (unlocked) {
        return <Outlet />;
    }

    if (!isStatusLoaded) {
        return null;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!password) {
            return;
        }
        dispatch(unlockRestrictedAccess(password));
    };

    return (
        <div className="flex items-center justify-center min-h-[70vh] px-4">
            <form
                onSubmit={handleSubmit}
                className="bg-white rounded-xl border-[1.5px] p-6 w-full max-w-[380px] flex flex-col gap-4"
            >
                <div className="flex flex-col items-center gap-2 text-center">
                    <div className="h-12 w-12 rounded-full bg-[#FFEFEF] flex items-center justify-center">
                        <LockKey size={24} color="#FF5A5F" />
                    </div>
                    <h3 className="font-semibold text-xl text-[#050F4E]">
                        Restricted access
                    </h3>
                    <p className="text-sm text-[#737880]">
                        Enter the access password to open {title}.
                    </p>
                </div>
                <div className="flex flex-col gap-1">
                    <label htmlFor="restricted-password" className="font-semibold text-sm">
                        Password
                    </label>
                    <input
                        id="restricted-password"
                        type="password"
                        autoFocus
                        placeholder="Enter access password"
                        className="border-[1.5px] w-full h-[40px] p-[8px] rounded-lg"
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                    />
                    {errorMessage ? (
                        <span className="text-sm text-[#FF5A5F]">{errorMessage}</span>
                    ) : null}
                </div>
                <button
                    className="w-full bg-[#FF7378] text-white font-medium h-[38px] rounded-lg disabled:opacity-60"
                    type="submit"
                    disabled={isVerifying || !password}
                >
                    {isVerifying ? "Checking..." : "Unlock"}
                </button>
                <button
                    type="button"
                    className="text-sm text-[#737880] underline"
                    onClick={() => navigate("/dashboard/request")}
                >
                    Back to requests
                </button>
            </form>
        </div>
    );
};

export default RestrictedRoute;
